<template>
  <div class="status-board d-print-none">
    <div class="row no-gutters">
      <div class="col-lg-4 p-2">
        <div class="status-glow is-sms">
          <div class="status-glow-icon">
            <i class="bi bi-chat-dots-fill"></i>
          </div>
          <div class="status-glow-copy">
            <span class="status-glow-label">پیامک باقی‌مانده</span>
            <strong class="status-glow-value">{{ formatNumber(smsRemaining) }}</strong>
            <span class="status-glow-unit">عدد آماده ارسال</span>
          </div>
          <m-a class="status-glow-btn" :href="{name:'ModulesList'}">خرید پیامک</m-a>
        </div>
      </div>

      <div class="col-lg-4 p-2">
        <div class="status-glow is-module">
          <div class="status-glow-icon">
            <i class="bi bi-puzzle-fill"></i>
          </div>
          <div class="status-glow-copy">
            <span class="status-glow-label">ماژول‌های فعال</span>
            <strong class="status-glow-value">{{ formatNumber(activeModules) }}</strong>
            <span class="status-glow-unit">افزونه در حال استفاده</span>
          </div>
          <m-a class="status-glow-btn" :href="{name:'ModulesList'}">ماژول جدید</m-a>
        </div>
      </div>

      <div class="col-lg-4 p-2">
        <div class="status-glow is-sub">
          <div class="status-glow-icon">
            <i class="bi bi-hdd-stack"></i>
          </div>
          <div class="status-glow-copy">
            <span class="status-glow-label">اشتراک و فضای ذخیره</span>
            <strong class="status-glow-value">{{ formatNumber(expireDays) }}</strong>
            <span class="status-glow-unit">روز تا تمدید</span>
            <div class="status-storage">
              <div class="status-storage-bar">
                <span :style="{width: storagePercent + '%'}"></span>
              </div>
              <small>{{ formatNumber(usedStorage) }} / {{ formatNumber(totalStorage) }} مگابایت</small>
            </div>
          </div>
          <m-a class="status-glow-btn" :href="{name:'ModulesList'}">تمدید اشتراک</m-a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter"

export default {
  name: "DashboardHeaderWidget",
  data() {
    return {
      items: {
        sms_remaining: 0,
        active_module: 0,
        site_service_expire: 0,
        use_subscription_storage: 0,
        storage_size: 0,
      },
    }
  },
  computed: {
    smsRemaining() {
      return Number(this.items.sms_remaining) || 0
    },
    activeModules() {
      return Number(this.items.active_module) || 0
    },
    expireDays() {
      return Number(this.items.site_service_expire) || 0
    },
    usedStorage() {
      return Number(this.items.use_subscription_storage) || 0
    },
    totalStorage() {
      const value = parseInt(this.items.storage_size, 10)
      return isNaN(value) ? 0 : value
    },
    storagePercent() {
      if (!this.totalStorage) {
        return 0
      }
      return Math.min(100, Math.round((this.usedStorage / this.totalStorage) * 100))
    },
  },
  methods: {
    formatNumber,
    pickValue(sources, key) {
      for (let i = 0; i < sources.length; i++) {
        const source = sources[i] || {}
        if (source[key] !== undefined && source[key] !== null && source[key] !== '') {
          return source[key]
        }
      }
      return 0
    },
    async loadData() {
      let status = {}
      let resources = {}
      try {
        const req = await this.$store.dispatch("DashboardSubscription/siteModuleStatus")
        status = (req && req.data && req.data.data) || {}
      } catch (e) {
        status = {}
      }
      try {
        const resourceReq = await this.$store.dispatch("DashboardResource/getResources")
        resources = (resourceReq && resourceReq.data && resourceReq.data.data) || {}
      } catch (e) {
        resources = {}
      }
      this.items = {
        sms_remaining: this.pickValue([status, resources], 'sms_remaining'),
        active_module: this.pickValue([status, resources], 'active_module'),
        site_service_expire: this.pickValue([status, resources], 'site_service_expire'),
        use_subscription_storage: this.pickValue([status, resources], 'use_subscription_storage'),
        storage_size: this.pickValue([resources, status], 'storage_size'),
      }
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>
.status-board {
  overflow-x: hidden;
  margin-bottom: 8px;
}

.status-board .col-lg-4 {
  display: flex;
}

.status-glow {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  padding: 10px 12px;
  color: #fff;
  width: 100%;
  height: 100%;
  min-height: 108px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 10px;
  background: #1e1e1e;
  box-shadow: 0 10px 22px rgba(30, 30, 30, 0.14);
}

.status-glow::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(rgba(255, 255, 255, 0.07) 1px, transparent 1px),
    linear-gradient(135deg, rgba(235, 61, 96, 0.18), transparent 52%);
  background-size: 12px 12px, auto;
  pointer-events: none;
}

.status-glow > * {
  position: relative;
  z-index: 1;
}

.status-glow.is-sms,
.status-glow.is-module,
.status-glow.is-sub {
  background: #1e1e1e;
}

.status-glow-copy {
  min-width: 0;
  flex: 0 1 auto;
}

.status-glow-icon {
  width: 36px;
  height: 36px;
  border-radius: 11px;
  background: rgba(235, 61, 96, 0.22);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}

.status-glow-label {
  display: block;
  font-size: 12px;
  opacity: 0.8;
}

.status-glow-value {
  display: block;
  font-size: 18px;
  line-height: 1.1;
  font-weight: 800;
  margin: 0;
}

.status-glow-unit {
  display: block;
  font-size: 11px;
  opacity: 0.75;
  margin: 0;
}

.status-storage {
  margin: 4px auto 0;
  max-width: 160px;
  width: 100%;
}

.status-storage-bar {
  height: 5px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.2);
  overflow: hidden;
  margin-bottom: 4px;
}

.status-storage-bar span {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: #fff;
}

.status-storage small {
  opacity: 0.85;
}

.status-glow-btn {
  margin-top: 0;
  align-self: center;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.12);
  color: #fff !important;
  border-radius: 999px;
  padding: 5px 10px;
  font-weight: 700;
  font-size: 11px;
  text-decoration: none !important;
  white-space: nowrap;
}

.status-glow-btn:hover {
  color: #fff !important;
  background: #eb3d60;
}

@media (max-width: 767px) {
  .status-glow {
    padding: 10px;
    gap: 8px;
  }

  .status-glow-value {
    font-size: 16px;
  }

  .status-glow-icon {
    width: 30px;
    height: 30px;
    font-size: 14px;
  }
}
</style>
